module.exports = __webpack_public_path__ + "img/edge_nature_domaine_viticole.f8f7e8b2.svg";